import { useEffect, useRef } from 'react';
import { useWorldStore } from '../state/worldStore';
import { IS_GUEST } from '../config';

// SpawnAsAvatar — when a MEMBER enters embodying one of their avatars that lives
// in the world (has a roster placement), fast-travel them to that avatar's spot
// once. The autonomous NPC is already hidden (NpcManager skips embodied ids), so
// the player takes its place. Uses the SERVER-resolved avatar id (chosen or first
// owned), so it works even if the member never opened the picker. If the avatar
// isn't placed in the world, nothing happens. Street residents only for now.
export default function SpawnAsAvatar() {
  const entered = useWorldStore((s) => s.entered);
  const npcList = useWorldStore((s) => s.npcList);
  const myAvatarId = useWorldStore((s) => s.myAvatarId);
  const setWalkTarget = useWorldStore((s) => s.setWalkTarget);
  const spawnedFor = useRef(null);

  useEffect(() => {
    if (IS_GUEST || !entered || !myAvatarId) return;
    if (spawnedFor.current === myAvatarId) return; // already warped to this avatar
    const me = (npcList || []).find((n) => n.avatarId === myAvatarId && Array.isArray(n.post));
    if (!me) return; // this avatar isn't placed in the world — spawn normally
    spawnedFor.current = myAvatarId;
    const [x, , z] = me.post;
    // Warp to this avatar's spot (works on first entry AND on mid-session switches).
    setWalkTarget({ pos: [x, 0, z], look: [x, 0, z + 3] });
  }, [entered, npcList, myAvatarId, setWalkTarget]);

  return null;
}
